<template>
  <v-container class="pa-0">
    <Subheader v-model="search" title="Discrete Station Categories" search="Discrete Station Categories">
      <v-btn dark color="success" @click="showAddType = true">
        <v-icon>add</v-icon>
        {{ $t('Button.Add_a_new_Category') }}
      </v-btn>
    </Subheader>
    <v-card>
      <v-card-text>
        <v-data-table :headers="headers" :items="stationCategories" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <td>
              <v-icon>{{ props.item.IconPath }}</v-icon>
              {{ props.item.Name }}
            </td>
            <td>{{ props.item.IconPath }}</td>
            <td class="text-xs-right">
              <v-flex>
                <v-btn depressed small @click="clickEditType(props.item)">{{ $t('Button.Manage_Category') }}</v-btn>
                <!-- <v-btn color="delete" dark @click="deleteCategory = props.item; dialog = true">Delete Type</v-btn> -->
              </v-flex>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showAddType" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationStationDiscreteCategory.addTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showAddType = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="addForm" ref="addFormRef" lazy-validation class="fullScreenWidth">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 pa-3>
                <v-text-field label="Category Name" v-model="newStationCategory.name" :rules="nameRules"></v-text-field>
                <v-select label="Icon Path" v-model="newStationCategory.iconPath" :items="iconList">
                  <template slot="selection" slot-scope="data">
                    <v-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-avatar>
                    {{ data.item }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>{{data.item}}</v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="success" @click="addNewType()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUpdateType" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationStationDiscreteCategory.editTitleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="showUpdateType = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="editForm" ref="editFormRef" lazy-validation class="fullScreenWidth">
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 pa-3>
                <v-text-field label="Category Name" v-model="editStationCategory.Name" :rules="editNameRules"></v-text-field>
                <v-select label="Icon Path" v-model="editStationCategory.IconPath" :items="iconList">
                  <template slot="selection" slot-scope="data">
                    <v-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-avatar>
                    {{ data.item }}
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-avatar>
                      <v-icon>{{data.item}}</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>{{data.item}}</v-list-tile-content>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="updateStationCategory()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="headline">Remove Category</v-card-title>
        <v-card-text>
          <p>{{ $t('AdministrationStationDiscreteCategory.confirmTitleMsg', { msg: deleteCategory.name }) }}</p>
          <p>{{ $t('AdministrationStationDiscreteCategory.confirmTextMsg') }}</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="dialog = false">
            <v-icon class="mr-1">delete_forever</v-icon>
            {{ $t('Button.Remove') }}
          </v-btn>
          <v-btn color="secondary" outline @click.native="dialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-snackbar class="snackbarAdjust" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import SideMenuUtil from '@/components/mixins/SideMenuUtil'
  const stations = createNamespacedHelpers('stations')
  export default {
    mixins: [SideMenuUtil],
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: 10,
        },
        headers: [{
          align: 'left',
          text: 'Category Name',
          value: 'name',
        },
        {
          align: 'left',
          text: 'Icon Path',
          value: 'iconPath',
        },
        {
          sortable: false,
          text: '',
          value: '',
        },
        ],
        dialog: false,
        showAddType: false,
        showUpdateType: false,
        snackbar: false,
        snackColor: '',
        snackMessage: '',
        addForm: true,
        editForm: true,
        newStationCategory: {},
        editStationCategory: {},
        typeListWithoutEdit: [],
        deleteCategory: {},

        nameRules: [
          v => !!v || 'Station Category name is required',
          v =>
          this.stationCategories.find(x => x.Name == v) == null ||
          'The media type name already exists',
        ],

        editNameRules: [
          v => !!v || 'Station Category name is required',
          v =>
          this.typeListWithoutEdit.find(x => x.Name == v) == null ||
          'The media type name already exists',
        ],
      }
    },
    mounted() {
      if (!this.stationCategories || !this.stationCategories.length) {
        this.getStationCategories()
      }
    },
    computed: {
      ...stations.mapGetters(['stationCategories', 'iconList']),
    },
    methods: {
      ...stations.mapActions([
        'getStationCategories',
        'postAddStationCategory',
        'putUpdateStationCategory',
      ]),
      addNewType() {
        if (this.$refs.addFormRef.validate()) {
          let options = {
            data: {
              Id: null,
              Name: this.newStationCategory.name,
              IconPath: this.newStationCategory.iconPath ?
                this.newStationCategory.iconPath : 'help',
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationStationDiscreteCategory.addNewTypeSuccessMsg', { msg: this.newStationCategory.name })
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
            },
            failedCb: err => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.postAddStationCategory(options)
        }
      },
      updateStationCategory() {
        if (this.$refs.editFormRef.validate()) {
          let options = {
            data: {
              Id: this.editStationCategory.Id,
              Name: this.editStationCategory.Name,
              IconPath: this.editStationCategory.IconPath ?
                this.editStationCategory.IconPath : 'help',
            },
            successCb: () => {
              this.snackMessage = this.$t('AdministrationStationDiscreteCategory.updateStationCategorySuccessMsg', { msg: this.editStationCategory.Name })
              this.snackColor = 'success'
              this.snackbar = true
              this.clearForm()
              this.stationCategoryChange()
            },
            failedCb: err => {
              this.snackColor = 'error'
              this.snackMessage = err
              this.snackbar = true
            },
          }
          this.putUpdateStationCategory(options)
        }
      },
      clearForm() {
        this.$refs.addFormRef.reset()
        this.showAddType = false
        this.showUpdateType = false
      },
      clickEditType(data) {
        this.showUpdateType = true
        this.editStationCategory = JSON.parse(JSON.stringify(data))
        this.typeListWithoutEdit = this.removeEditType(data)
      },
      removeEditType(data) {
        let typeList = JSON.parse(JSON.stringify(this.stationCategories))
        let type = typeList.find(x => x.Name == data.Name)
        let i = typeList.indexOf(type)
        typeList.splice(i, 1)
        return typeList
      },
    },
  }
</script>

<style scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  .fullScreenWidth {
    width: 100%;
  }

  .fontSize {
    font-size: 14px !important;
  }

  .titleAdjust {
    padding-top: 50px;
  }

  .iconAdjust {
    padding-bottom: 10px;
  }

  .snackbarAdjust {
    text-align: center;
  }
</style>